<style src="./BalanceHistory.scss" lang="scss"></style>
<template>
  <section class="BalanceHIstory">
    <div class="ibox">
      <div class="ibox-content">

        <h2 class="title is-4" title="Historico detalhado da compra de crédito para a carteira">Histórico de Compra</h2>
        
        
        <div class="table-responsive content">
          <Spinner v-if="isLoading" />
          <div class="text-center" v-if="!isLoading && list.length === 0">
            <h3>Nenhum registro encontrado!</h3>
            <div class="error-desc">
              Não foram encontrados nenhuma compra de crédito para a carteira deste cliente.
            </div>
          </div>

          <table class="table table-striped table-hover" v-if="!isLoading && list.length > 0">
            <thead>
              <tr>
                <th></th>
                <th>Status</th>
                <th>Data</th>
                <th>Hora</th>
                <th>Tipo</th>
                <th>Código</th>
                <th class="balance">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <td class="client-status details"><i class="fa fa-info-circle" @click="showDetails(item)"></i></td>
                  <td class="client-status status"><span class="label" :class="paidStyle(item.paid)">{{ item.paid | paidStatus }}</span></td>
                  <td class="date">{{ item.dateCreated | formatDate }}</td>
                  <td class="hours">{{ item.dateCreated | formatTime}}</td>
                  <td class="client-status paymenttype"><span class="label" :class="methodStyle(item.method)">{{ item.method }}</span></td>
                  <td class="code"><small>{{ item.transactionId }}</small></td>
                  <td class="text-success balance"><small>R$</small> {{ item.amountPaid | formatCurrency}}</td>
              </tr>
            </tbody>
          </table>
          <div>
            <table class="table invoice-total">
              <tbody>
                <tr>
                  <td><strong>Total :</strong></td>
                  <td class="text-success balance">R$ {{ totalAmount | formatCurrency}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-right">
          <div class="btn-group">
            <button class="btn btn-white" type="button" :disabled="previousButtonDisabled" @click="previousPage">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button class="btn btn-white" type="button" :disabled="nextButtonDisabled" @click="nextPage">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal inmodal in" id="myModal5" tabindex="-1" role="dialog" style="display: block;" v-if="isModalVisible">
      <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
                <h4 class="modal-title">Detalhes da Compra</h4>
                <small class="font-bold">Compra efetuada para a carteira do usuário</small>
            </div>
            <div class="modal-body">
              <table class="modalinfo">
                <tbody>
                  <tr>
                    <td class="title"><strong>Código da Transação:</strong></td>
                    <td>{{ details.transactionId }}</td>
                  </tr>
                  <tr>
                    <td class="title"><strong>Data do Registro:</strong></td>
                    <td>{{ details.dateCreated | formatDate}}</td>
                  </tr>
                  <tr>
                    <td class="title"><strong>Hora do Registro:</strong></td>
                    <td>{{ details.dateCreated | formatTime}}</td>
                  </tr>
                  <tr>
                    <td class="title"><strong>Data do Pagamento:</strong></td>
                    <td>{{ details.datePayment | formatDate}}</td>
                  </tr>
                  <tr>
                    <td class="title"><strong>Hora do Pagamento:</strong></td>
                    <td>{{ details.datePayment | formatTime}}</td>
                  </tr>
                  <tr>
                    <td class="title"><strong>Valor Pago:</strong></td>
                    <td> R$ {{ details.amountPaid | formatCurrency}}</td>
                  </tr>
                  <tr>
                    <td class="title"><strong>Método de Pagamento:</strong></td>
                    <td>{{ details.method }}</td>
                  </tr>
                  <tr>
                    <td class="title"><strong>Status do Pagamento:</strong></td>
                    <td>{{ details.paid | paidStatus}}</td>
                  </tr>
                  <tr>
                    <td class="title"><strong>Mensagem:</strong></td>
                    <td>{{ details.status }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-white" data-dismiss="modal" @click="closeModal">Fechar</button>
            </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Spinner from '@/components/Spinner';
export default {
  components: {
    Spinner,
  },
  data() {
    return {
      isLoading: false,
      list: [],
      totalAmount: 0,
      countTotal: 0,
      pageSkip: 0,
      pageLimit: 6,
      isModalVisible: false,
      details: {
        dateCreated: '',
        datePayment: '',
        transactionId: '',
        amountPaid: 0,
        method: '',
        paid: false,
        movementType: ''
      }
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return ''
      const date = new Intl.DateTimeFormat('pt-BR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }).format(new Date(value));

      return date;
    },
    formatTime(value) {
      if (!value) return ''
      const time = new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(value));

      return time;
    },
    formatCurrency(value) {
      if (!value) {
        return '0,00';
      }
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    paidStatus(value) {
      if (value) {
        return 'Pago';
      }
      return 'Pendente';
    }
  },
  mounted() {
    this.loadInfo();
  },
  computed: {
    previousButtonDisabled() {
      return this.pageSkip === 0;
    },
    nextButtonDisabled() {
      return this.pageSkip + this.pageLimit >= this.countTotal;
    }
  },
  methods: {
    async loadInfo() {
      try {
        this.isLoading = true;
        
        const payload = {
          pageSkip: this.pageSkip,
          pageLimit: this.pageLimit,
          user: this.$route.params.userToken,
        };
        const buyHistory = await this.$store.dispatch(
          'CONSUMER/BuyHistory',
          payload,
        );

        this.list = buyHistory.history;
        this.countTotal = buyHistory.countTotal;
        this.totalAmount = buyHistory.totalAmountPaid;
      } catch(error) {
        console.error('Error loading consumer info:', error);
      } finally {
        this.isLoading = false;
      }
    },
    nextPage() {
      this.pageSkip += this.pageLimit;
      this.loadInfo();
    },
    previousPage() {
      this.pageSkip -= this.pageLimit;
      this.loadInfo();
    },
    showDetails(item) {
      console.log('item', item)
      this.details.dateCreated = item.dateCreated;
      this.details.datePayment = item.paymentDate;
      this.details.transactionId = item.transactionId;
      this.details.amountPaid = item.amountPaid;
      this.details.method = item.method;
      this.details.paid = item.paid;
      this.details.status = item.status;

      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    methodStyle(method) {
      switch (method) {
        case 'PIX':
          return 'label-success';
        case 'Cartão':
          return 'label-warning';
        case 'Bônus':
          return 'label-info';
        default:
          return '';
      }
    },
    paidStyle(paid) {
      if (paid) {
        return 'label-primary';
      }
      return 'label-danger';
    } 
  }
};
</script>
